import * as React from "react";
import { useEffect, useRef, useState } from "react";
//@ts-ignore
import { Stack, Show, Hide, Wrap, WrapItem, Tag, Flex, VStack, Text, Heading, Box, Grid, GridItem, Image, FormControl, FormLabel, InputGroup, InputLeftAddon, Button, Badge, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Link, FormErrorMessage, Spacer, HStack, Tooltip, Popover, PopoverTrigger, PopoverContent, PopoverAnchor, PopoverCloseButton, PopoverBody, PopoverArrow, PopoverHeader, Alert, AlertIcon, AlertTitle, Input, propNames, useToast, color, InputLeftElement, useStatStyles, Skeleton, Progress } from "@chakra-ui/react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { GetDateTimeFromTimestamp, GetDateTimeFromTimestampRounded, GetGreeting, GetLongDateFormat, GetDate, GetShortDateFormat } from "../../../helpers/DateTimeHelpers";
import IProduct from "../../../interfaces/products/IProduct";
import { IWipLine, WiplineStatus } from "../../../interfaces/jobsheets/IWipline";
import { useDictionary } from "../../../reducers/useDictionary";
import { PageContainer, PortalPageType } from "../../components/container";
import * as webHelpers from "../../../helpers/WebHelpers";
import { IJobsheet, JobsheetStatus } from "../../../interfaces/jobsheets/IJobsheet";
import { extendTheme } from "@chakra-ui/react";
import { validateEmail } from "../../../../../client/src/helpers/EmailHelper";
import { Textarea } from "@chakra-ui/react"
import SquarePaymentFormExisting from "../../components/square/payment/takeExisting";

//Dummy Response
import * as JS from '../../../DummyResponse/Jobsheet.json';
import { DummyWIP } from "../../../DummyResponse/WipLine";
import * as Product from '../../../DummyResponse/Product.json';
import { DummyRTC } from "../../../DummyResponse/RTC";
import * as WorkReport from "../../../DummyResponse/WorkReport.json";

import { MdPadding, MdPinDrop } from 'react-icons/md';
import { MdCalendarToday } from 'react-icons/md';
import { MdSchedule } from 'react-icons/md';
import { MdHomeRepairService } from 'react-icons/md';
import { MdHelpOutline } from 'react-icons/md';
import { MdCalendarViewMonth } from "react-icons/md";
import { MdCalendarViewWeek } from "react-icons/md";
import { GoCalendar, GoBriefcase, GoWatch } from "react-icons/go";
import { IconButton } from '@chakra-ui/react'
import { Checkbox, CheckboxGroup } from '@chakra-ui/react'
import { MdSentimentNeutral } from 'react-icons/md';
import { MdSentimentVeryDissatisfied } from 'react-icons/md';
import { MdSentimentSatisfied } from 'react-icons/md';
import { BiLinkExternal } from "react-icons/bi";
import { MdAlternateEmail } from "react-icons/md";
import { BiRename } from "react-icons/bi";
import { MdDriveFileRenameOutline } from "react-icons/md"
import { TbMoodHappy } from "react-icons/tb";
import { TbMoodSad } from "react-icons/tb";
import { MdPrint } from 'react-icons/md';


// import LocationIcon from "@mui/icons-material/PinDrop";
// import CalendarIcon from "@mui/icons-material/CalendarMonth";
// import TimeIcon from "@mui/icons-material/Schedule";
// import WorkIcon from "@mui/icons-material/HomeRepairService";
// import HelpIcon from "@mui/icons-material/HelpOutline";
//@ts-ignore
import TagManager from 'react-gtm-module';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import { ProjectWorkspace } from "jest-editor-support";
import { IRightToCancel } from "../../../interfaces/jobsheets/IRightToCancel";
import { IWorkReport, SatisfactionRating } from "../../../interfaces/jobsheets/IWorkReport";
import { ICard } from "../../../interfaces/square/ICard"
import { JobStageStepper } from "./components/JobStageStepper";
import SquareTokenizeForm from "../../components/square/tokenize";
import SquarePaymentForm from "../../components/square/payment";
import RTCView from "./components/RightToCancel";
import WorkCompletedView from "./components/WorkReport";
import { DescriptionOfWorks } from "./components/DescriptionOfWorks";
import { FiExternalLink } from "react-icons/fi";
import { cp } from "node:fs";
import e from "express";
import { registerDomainRequestSchema } from "square/dist/models/registerDomainRequest";
import { ErrorBoundary } from 'react-error-boundary';
import { useErrorHandler } from "react-error-boundary";
import loadingGif from "../.../../../../../src/assets/loadingIcon.gif"
import loadingError from "../.../../../../../src/assets/loadingErrorScreen.png"
import { useTimer } from "use-timer"
import { MdOutlineTimer } from "react-icons/md"
import moment from "moment";
import { CompletedWorkSummary } from "./components/CompletedWorkSummary";
import { useReactToPrint } from "react-to-print";
import { relative } from "node:path";
import { Pricing } from "./components/Pricing";
import { CustomerType } from "../../../interfaces/jobsheets/ICustomer";
import { InvoiceConfirmation } from "./components/InvoiceConfirmation";
import { AppointmentDetails } from "./components/AppointmentOverview";
import { PoisonCoshhSummary } from "./components/CompletedWorkSummary/PoisonCoshhSummary";

export enum JobOverviewStage {
    Cancelled = -100,
    AwaitingEngineer = 0,
    EngineerAllocated,
    Assessment,
    RightToCancel,
    Ordering,
    WorkInProgress,
    WorkReport,
    PendingCompletion,
    Payment,
    Completed
}

const useProductsDictionary = function () {
    const {
        state,
        onUpdateValue,
        onClearValue,
        onClear
    } = useDictionary<{ [id: string]: IProduct }, string>({});

    return {
        products: state, onUpdateProduct: onUpdateValue, onClearProduct: onClearValue, onClearProducts: onClear
    }
}

export const Dashboard = () => {
    const navigate = useNavigate();
    const sendDataToGTM = useGTMDispatch();

    const { jobNumber } = useParams();

    const [stage, setStage] = useState<JobOverviewStage>(0);
    const [showInteractionOnly, setShowInteractionOnly] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(false);

    const [jobsheet, setJobsheet] = useState<IJobsheet | null>(null);
    const [wipLines, setWiplines] = useState<IWipLine[]>([]);
    const [appointmentWipLines, setAppointmentWiplines] = useState<IWipLine[]>([]);
    const [otherWipLines, setOtherWipLines] = useState<IWipLine[]>([]);
    const [rightToCancel, setRightToCancel] = useState<IRightToCancel | null>(null);
    const [workReport, setWorkReport] = useState<IWorkReport | null>(null);

    const [paymentValue, setPaymentValue] = useState<number>(0);
    const [modalPayment, setModalPayment] = useState<number>(0);
    const [paymentModalOpen, setPaymentModalOpen] = useState<boolean>(false);

    const [timeInfoPopOpen, setTimeInfoPopOpen] = useState<boolean>(false);
    const [paymentErrorMsg, setPaymentErrorMsg] = useState<String>("");

    const toast = useToast();
    const prevPVRef = React.useRef<number>();
    const prevSCRef = React.useRef<boolean>(false);

    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [notes, setNotes] = useState<string>("");
    const [loadingButton, setLoadingButton] = useState<boolean>(false);
    const [formIsSent, setFormIsSent] = useState<boolean>(false);
    const [satisfaction_rating, setSatisfaction] = useState<SatisfactionRating>(SatisfactionRating.undefined);
    const [hasCardDetails, setHasCardDetails] = useState<boolean>(false);
    const [cardDetails, setCardDetails] = useState<ICard | null>();
    const [showError, setError] = useState<boolean>(true);
    const [getSecondCard, setSecondCard] = useState<boolean>(false);

    const [showYesNo, setYesNo] = useState<boolean>(true);
    const [showTokeniseForm, setShowTokeniseForm] = useState<boolean>(false);
    const [showBox, setShowBox] = useState<boolean>(true);
    const [timedOut, setTimedOut] = useState<boolean>(false);
    const { time, start, pause, reset, status } = useTimer({
        endTime: 7,
        onTimeOver: () => {
            setTimedOut(true);
        }
    })

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    /*useEffect(() => {
        console.log("satisfaction updated, new satisfaction is ", satisfaction_rating)
        if(workReport != null){
            //workReport.SatisfactionRating = satisfaction_rating;
        }
        let data = {
            satisfaction_rating: satisfaction_rating,
            signee_name: workReport?.SigneeName
        }
        webHelpers.postAsync('/api/sales/work/workreport/sign?job=' + jobNumber,data).then(res => {
            console.log("satisfaction = ", workReport?.SatisfactionRating);
            console.log('/api/sales/work/workreport/sign?job=' + jobNumber,data);
        }
        ).catch(err => {
            console.log(err);
        }
        )
        //refresh();
        //setSatisfaction(SatisfactionRating.undefined);
    },[satisfaction_rating]) */

    //as of yet this function only captures data, will do something with it later
    function handleSubmit() {
        console.log("name: ", name, ", email: ", email, ", notes: ", notes, ", Job Number: ", jobNumber);
        setFormIsSent(true);

    }
    //have to use previous value of payment value otherwise the "payment successful" toast will reference an out of date variable
    useEffect(() => {
        prevPVRef.current = paymentValue;
    }, [paymentValue])
    useEffect(() => {
        prevSCRef.current = getSecondCard;
    }, [getSecondCard])

    useEffect(() => {
        console.log(jobsheet);
    }, [jobsheet]);
    const {
        products,
        onUpdateProduct,
        onClearProduct,
        onClearProducts
    } = useProductsDictionary();

    // Getters
    // These call information about the Jobsheet from the API 
    const getJobsheet = async () => {
        return await webHelpers.getAsync<IJobsheet | null>(
            "/api/sales/work/jobsheet" + (jobNumber == null ? "" : "?job=" + jobNumber),
            //undefined, JS // Comment this line out when running server
        );
    };

    const getWiplines = async () => {
        return await webHelpers.getAsync<IWipLine[]>(
            "/api/sales/work/jobsheet/wiplines" + (jobNumber == null ? "" : "?job=" + jobNumber),
            //undefined, DummyWIP  // Comment this line out when running server
        );
    }

    const getAppointmentWiplines = async () => {
        return await webHelpers.getAsync<IWipLine[]>(
            "/api/sales/work/appointment/wiplines" + (jobNumber == null ? "" : "?job=" + jobNumber),
            //undefined, DummyWIP  // Comment this line out when running server
        );
    }

    const getProduct = async (id: string) => {
        return await webHelpers.getAsync<IProduct>(
            "/api/sales/products/catalogue/item/get?id=" + id,
            //undefined, Product // Comment this line out when running server
        );
    }

    const getRightToCancel = async () => {
        return await webHelpers.getAsync<IRightToCancel>(
            "/api/sales/work/jobsheet/rtc" + (jobNumber == null ? "" : "?job=" + jobNumber),
            //undefined, DummyRTC // Comment this line out when running server
        );
    }

    const getWorkReport = async () => {
        return await webHelpers.getAsync<IWorkReport>(
            "/api/sales/work/workreport" + (jobNumber == null ? "" : "?job=" + jobNumber),
            //undefined, WorkReport // Comment this line out when running server
        );
    }

    // These functions are used by the webpage to calculate what stage of the process the Job is on
    const isWipAssessed = (): boolean => {
        console.log(appointmentWipLines.length);
        console.log(otherWipLines.length);

        if (appointmentWipLines.length <= 0) {
            return false;
        }

        //First check if those in the other appointments have been assessed.
        //If they have this a second appointment and should be marked as past assessment stage.
        if (otherWipLines.length > 0) {
            let otherAssessed = true;
            otherWipLines.forEach(wip => {
                if (wip.is_assessed == false) {
                    otherAssessed = false;
                }
            });
    
            if (otherAssessed) return true; //All items in a previous appointment have been assessed - jump straight to in progress stage
        }

        //Otherwise check the current appointment for any that have not been assessed
        let apptAssessed = true;
        appointmentWipLines.forEach(wip => {
            if (wip.is_assessed == false) {
                apptAssessed = false;
            }
        });

        return apptAssessed;
    }

    const isWipOrdering = (): boolean => {
        let result = false;

        wipLines.forEach(wip => {
            if (wip.status >= WiplineStatus.Orderable && wip.status < WiplineStatus.Ready) {
                result = true;
            }
        })

        return result;
    }

    const isWipCompleted = (): boolean => {
        let result = true;

        wipLines.forEach(wip => {
            if (wip.status < WiplineStatus.Completed) {
                result = false;
            }
        })

        return result;
    }
    //if true the user will be shown an additional checkbox when signing RTC 
    const isWipDamaging = (): boolean => {
        let result = false;
        wipLines.forEach(wip => {
            if (wip.is_damage_line) {
                result = true;
            }
        })

        return result;
    }
    const handlePayment = () => {
        webHelpers.postAsync("/api/payment/take/existing", { amount: paymentValue }).then(test => { setLoadingButton(false); setSecondCard(false); refresh(); showPaymentToastFixed(); });

        setLoadingButton(true);
    }
    const throwError = () => {
        if (showError) {
            throw new Error("this is a test error message");
        }
    }

    const calculateStage = (): void => {
        setShowInteractionOnly(false);

        if (jobsheet == null) {
            console.log("Unable to calculate job stage, jobsheet is null");
            return;
        }
        
        //If the query codes is one of these three override stage calculation here and hence the return statements
        if (jobsheet.status == JobsheetStatus.OnQuery) {
            if (jobsheet.status_reason?.friendly_id === "ordering-awaiting-deposit") {
                setStage(JobOverviewStage.Ordering);
                return;
            }
            else if (jobsheet.status_reason?.friendly_id === "awaiting-pre-payment") {
                setStage(JobOverviewStage.WorkInProgress);
                return;
            }
            else if (jobsheet.status_reason?.friendly_id === "web") {
                setStage(JobOverviewStage.AwaitingEngineer);
                return;
            }
            else if (jobsheet.status_reason?.friendly_id === "invconf") {
                setStage(JobOverviewStage.AwaitingEngineer);
                setShowInteractionOnly(true);
                return;
            }
        }

        //If not on query or the query code is not one specific to the customer portal, calculate job stage as normal
        if (jobsheet.status <= JobsheetStatus.PendingCancellation) {
            setStage(JobOverviewStage.Cancelled);
        }
        else if (jobsheet.status < JobsheetStatus.Completed) {
            if (isWipAssessed()) {
                if (rightToCancel?.is_signed || jobsheet.customer?.Type == CustomerType.Premium || !rightToCancel?.allow_digital) {
                    if (isWipCompleted()) {
                        if (workReport?.IsSigned || !rightToCancel?.allow_digital) {
                            setStage(JobOverviewStage.PendingCompletion);
                        }
                        else {
                            setStage(JobOverviewStage.WorkReport);
                        }
                    }
                    else if (isWipOrdering()) {
                        setStage(JobOverviewStage.Ordering);
                    }
                    else {
                        setStage(JobOverviewStage.WorkInProgress);
                    }
                }
                else {
                    setStage(JobOverviewStage.RightToCancel);
                }
            }
            else if (jobsheet.appointment?.allocation != null && jobsheet.appointment.allocation.on_site_timestamp) {
                setStage(JobOverviewStage.Assessment);
            }
            else {
                setStage(JobOverviewStage.AwaitingEngineer);
            }
        }
        else if (jobsheet.value_gross - jobsheet.value_paid > 0) {
            setStage(JobOverviewStage.Payment);
        }
        else {
            setStage(JobOverviewStage.Completed);
        }
    }
    // useEffect(() => {
    //     if (cardDetails?.card === null) { console.log("card is null") }
    //     else {
    //         if (cardDetails?.card.card_number !== null && cardDetails?.card.card_number !== undefined) {
    //             console.log("card number is ", cardDetails?.card.card_number);
    //             setHasCardDetails(true);
    //         }
    //     }
    //     console.log("hasCardDetails[effect] = ", hasCardDetails);
    // }, [hasCardDetails]);


    const refresh = () => {
        // As of current while the page is loading after 7 seconds a timed out error will be shown
        setTimedOut(false);
        start(); //used to start the timedOut timer

        if (prevSCRef.current === false) {
            //this code is used to check if the customer already has a card saved on Echo
            webHelpers.getAsync<ICard>("/api/get/card/details").then(
                cd => {
                    setCardDetails(cd);
                    if (cd?.card === null || cd?.card === undefined) { //no card found on system
                        setHasCardDetails(false)
                    }
                    else {
                        if (cd == null) {
                            setHasCardDetails(false);
                        }
                        else if (cd?.card?.card_number === undefined || cd?.card?.card_number === null) {
                            setHasCardDetails(false);
                        }
                        else {
                            setHasCardDetails(true)
                        }
                    }
                }
            ).catch(errortest => {
                //this means no card details were found, in this scenario the user will be asked to enter card details
                setHasCardDetails(false);
                console.log("caught error")
            });
        }
        else {
            setHasCardDetails(false);
        }

        // console.log(cardDetails?.card.card_number);
        // console.log("HasCardDetails?=", hasCardDetails);
        // console.log("cardDetails = ", cardDetails?.card);
        // console.log("Overview Page Refreshed");

        getJobsheet().then(js => {
            if (js == null) {
                console.log("Jobsheet is null");
                return;
            }
            console.log(jobsheet?.address);
            setJobsheet(js);
            console.log(jobsheet?.id);
            getWiplines().then(wips => {
                if (wips != null) {
                    Object.values(wips).forEach(async wip => {
                        getProduct(wip.line_data.product_id).then(product => {
                            if (product != null) {
                                onUpdateProduct(product.id, product);
                            }
                        });
                    })
                    setWiplines(Object.values(wips));

                    if (js?.appointment?.allocation != undefined) {
                        getAppointmentWiplines().then(apptWips => {
                            if (apptWips != null) {
                                setAppointmentWiplines(apptWips);
                                console.log("appt wips = ", apptWips);
                                let apptIds: string[] = apptWips.map((item) => item.id);
                                let otherWips: IWipLine[] = [];
                                wips.forEach(wip => {
                                    if (apptIds.includes(wip.id) === false) {
                                        otherWips = [
                                            ...otherWips,
                                            wip
                                        ]
                                    }
                                });
                                setOtherWipLines(otherWips);
                            } else {
                                setAppointmentWiplines(wips);
                            }
                        })
                    } else {
                        setAppointmentWiplines(wips);
                    }
                }
            });

            if (js.status == JobsheetStatus.OnQuery && js.value_deposit_expected) {
                setPaymentValue(Math.max(0, js.value_deposit_expected - js.value_paid));
                console.log("Deposit: " + js.value_deposit_expected);
                console.log("Paid: " + js.value_paid);
            }
            else {
                setPaymentValue(js.value_gross - js.value_paid);
            }

            getRightToCancel().then(rtc => {
                setRightToCancel(rtc);
                console.log(rtc);
            });

            getWorkReport().then(wr => {
                setWorkReport(wr);
                console.log("work report", wr);
            });
        }).catch(reason => {
            //navigate("/customer/signout");
            setLoading(false);
            console.log("could not get jobsheet");
        });
    }

    const openPaymentModal = (): void => {
        setModalPayment(paymentValue);
        setPaymentModalOpen(true);
    }

    const setPaymentFromModal = (): void => {
        if (modalPayment > 0.01 && jobsheet) {
            if (modalPayment > jobsheet?.value_gross - jobsheet?.value_paid) {
                setPaymentValue(jobsheet?.value_gross - jobsheet?.value_paid)
            } else {
                setPaymentValue(modalPayment);
            }
        }
        sendDataToGTM({ event: "customer_changed_payment_value", customPaymentValue: modalPayment });
        setPaymentModalOpen(false);
    }

    const isInvalidPayment = () => {
        if (jobsheet == null) return true;

        if (modalPayment < 0.01 || modalPayment > jobsheet.value_gross - jobsheet.value_paid) {
            return true;
        }

        if (jobsheet.status == JobsheetStatus.OnQuery && jobsheet.value_deposit_expected && modalPayment < jobsheet.value_deposit_expected - jobsheet.value_paid) {
            return true;
        }

        return false;
    }
    //runs when a card has been tokenised by square successfully 
    const handleTokeniseCompleted = async (token: string, verificationToken: string) => {
        if (jobsheet == null) return;

        await webHelpers.postAsync("/api/verify/card/details", { job: jobsheet.id, token: token, appointment: jobsheet?.appointment, verification_token: verificationToken }).then(cb => {
            showCardStoreToast();
            setSecondCard(false)
            setHasCardDetails(true);
            setShowBox(false);
            refresh();
        });
        //This will throw error if the above call fails, so below will only continue if OK

    }

    const handleDepositTaken = () => {
        showPaymentToast(paymentValue);
        refresh();
    }

    const showCardStoreToast = () => {
        toast({
            title: "Card Details Verified Successfully",
            status: "success",
            duration: 10000,
            isClosable: true
        });
    }

    const showPaymentToast = (value: number) => {
        toast({
            title: "Payment Successful",
            description: "You made a payment of £" + paymentValue.toFixed(2),
            status: "success",
            duration: 10000,
            isClosable: true
        })
    }
    const showPaymentToastFixed = () => {
        toast({
            title: "Payment Successful",
            description: "You made a payment of £" + Number(prevPVRef.current).toFixed(2),
            status: "success",
            duration: 10000,
            isClosable: true
        })
        refresh();
    }
    const useNewCard = () => {
        setSecondCard(true);
        setHasCardDetails(false);
    }
    const addPaymentMethodForm = () => {
        setYesNo(false);
        setShowTokeniseForm(true);
    }
    const dontAddMethod = () => {
        setShowBox(false);
    }
    const useCardOnFile = () => {
        setSecondCard(false);
    }
    const [sentiment, setSentiment] = useState<number>(-1);

    const getInteraction = (): JSX.Element => {
        if (loading || jobsheet == null) return <></>

        else if (jobsheet.status == JobsheetStatus.OnQuery) {
            if (jobsheet.status_reason?.friendly_id == "web") {
                return (
                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                        <Flex borderWidth='2px' borderColor='gray.200' borderRadius='lg' mt={4} p={2} align='center' justify={'center'}>
                            <Flex align='center' direction='column'>
                                <Flex direction='column' alignItems={'center'}>
                                    <Heading size="md" color='var(--Able-blue)'>Payment Details</Heading>
                                    <Text pl={2} pt={2} align='center'>Before progressing further, we ask for your card details to secure your job.</Text>
                                    <Text pl={2} align='center'>You will NOT be charged until after the work is completed, or if a deposit is needed.</Text>
                                </Flex>

                                <SquareTokenizeForm callback={handleTokeniseCompleted} billingContact={jobsheet.customer} />
                                {/* <Button ml={10} colorScheme='blue' onClick={() => navigate("/customer/capture/" + jobNumber, {replace: true})}>Enter Card Details</Button> */}
                            </Flex>
                        </Flex>
                    </ErrorBoundary>
                )
            } else if (jobsheet.status_reason?.friendly_id == "ordering-awaiting-deposit") {
                return (
                    <Flex borderWidth='2px' borderColor='gray.200' borderRadius='lg' mt={4} p={2} direction='column' align='center' justify={'center'}>
                        <Flex direction='column'>
                            <Heading size="md" color='var(--Able-blue)' textAlign={"center"}>Deposit Required</Heading>
                            <Text pl={2} pt={2} textAlign='center'>To complete your work, one or more items have been placed on order. Before continuing, a deposit is needed.</Text>
                            <Text pl={2} pt={2} textAlign='center'>Deposit valid until {GetLongDateFormat(jobsheet.quote_expiration_date)}</Text>
                        </Flex>

                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            {/* moment() here defaults to the current time */}
                            {moment().isSameOrBefore(jobsheet.quote_expiration_date, "day") ?
                                <>
                                    {!hasCardDetails || cardDetails?.card?.is_sca === false ?
                                        <Flex p={2} direction='column' align='center'>

                                            {cardDetails?.card?.is_sca === true && <Text pl={2} pt={2} textAlign='center'>We already have a card on file but for verification purposes please enter your details again</Text>}

                                            <Text mt={5}>Deposit Value: <b>£{paymentValue.toFixed(2)}</b></Text>

                                            <Flex direction='row'>
                                                <Button colorScheme='blue' variant='ghost' ml={4} onClick={openPaymentModal}>Change Amount</Button>
                                                {jobsheet.value_deposit_expected != null &&
                                                    <Button colorScheme='blue' variant='ghost' ml={4} onClick={() => setPaymentValue(jobsheet?.value_deposit_expected ?? 0)}>Reset</Button>
                                                }
                                                <Button colorScheme='blue' variant='ghost' ml={4} onClick={() => setPaymentValue(jobsheet.value_gross - jobsheet.value_paid)}>Pay Balance Now</Button>
                                            </Flex>
                                            <SquarePaymentForm amount={paymentValue} billingContact={jobsheet.customer} callback={showPaymentToastFixed} />
                                        </Flex>
                                        :
                                        // if we have a card on file must first check it is SCA
                                        <Flex>
                                            {cardDetails?.card?.is_sca === true &&
                                                <Flex mt={4} p={2} direction='column' align='center'>

                                                    <Flex direction='column'>
                                                        <Text align='center'> We already have a payment method on you account</Text>
                                                        <Text align='center'> Would you like to use the card &#8226;&#8226;&#8226;&#8226; &#8226;&#8226;&#8226;&#8226; &#8226;&#8226;&#8226;&#8226; {cardDetails?.card.card_number}?</Text>
                                                        <Flex direction='row' justify="center">
                                                            <Flex direction='row' justify="center">
                                                                <Link color='blue.500' onClick={useNewCard}>Change Card</Link>
                                                            </Flex>
                                                            <div id="#card-container"></div>
                                                        </Flex>
                                                    </Flex>

                                                    <Text mt={5}>Deposit Value: <b>£{paymentValue.toFixed(2)}</b></Text>

                                                    <Flex direction='row'>
                                                        <Button colorScheme='blue' variant='ghost' ml={4} onClick={openPaymentModal}>Change Amount</Button>
                                                        {jobsheet.value_deposit_expected != null &&
                                                            <Button colorScheme='blue' variant='ghost' ml={4} onClick={() => setPaymentValue(jobsheet?.value_deposit_expected ?? 0)}>Reset</Button>
                                                        }
                                                        <Button colorScheme='blue' variant='ghost' ml={4} onClick={() => setPaymentValue(jobsheet.value_gross - jobsheet.value_paid)}>Pay Balance Now</Button>

                                                    </Flex>
                                                    {!getSecondCard ?
                                                        <SquarePaymentFormExisting amount={paymentValue} billingContact={jobsheet.customer} customerId={jobsheet.id} sci={cardDetails?.card.square_card_identifier} callback={refresh} />
                                                        :
                                                        <SquarePaymentForm amount={paymentValue} billingContact={jobsheet.customer} callback={refresh} />
                                                    }
                                                </Flex>
                                            }
                                        </Flex>
                                    }
                                </>
                                :
                                <Flex direction='column' align='center'>
                                    <Text mt={5}>Deposit Value: <b>£{paymentValue.toFixed(2)}</b></Text>
                                    <Text mt={5} align='center'>The deposit you were quoted has expired. Please contact us to continue with this work.</Text>
                                </Flex>
                            }

                        </ErrorBoundary>
                    </Flex>
                )
            } else if (jobsheet.status_reason?.friendly_id == "awaiting-pre-payment") {
                return (
                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                        <Flex borderWidth='2px' borderColor='gray.200' borderRadius='lg' mt={4} p={2} direction='column' align='center' justify={'center'}>
                            {!hasCardDetails || cardDetails?.card?.is_sca === false ||  cardDetails?.card?.is_sca === undefined ?
                                <ErrorBoundary FallbackComponent={ErrorFallback}>

                                    <Flex mt={4} p={2} direction='column' align='center'>

                                        <Flex direction='column'>
                                            <Heading size="md" color='var(--Able-blue)' textAlign={"center"}>Payment Required</Heading>
                                            <Text pl={2} pt={2} textAlign='center'>For this job, payment is needed after the first visit</Text>
                                            {/* @ts-ignore */}
                                            {cardDetails?.card?.is_sca === true && !getSecondCard && <Text pl={2} pt={2} textAlign='center'>We already have a card on file but for verification purposes please enter your details again</Text>}
                                        </Flex>

                                        <Text mt={5}>Deposit Value: <b>£{paymentValue.toFixed(2)}</b></Text>

                                        <Flex direction='row'>
                                            <Button colorScheme='blue' variant='ghost' ml={4} onClick={openPaymentModal}>Change Amount</Button>
                                            {jobsheet.value_deposit_expected != null &&
                                                <Button colorScheme='blue' variant='ghost' ml={4} onClick={() => setPaymentValue(jobsheet?.value_deposit_expected ?? 0)}>Reset</Button>
                                            }
                                            <Button colorScheme='blue' variant='ghost' ml={4} onClick={() => setPaymentValue(jobsheet.value_gross - jobsheet.value_paid)}>Pay Balance Now</Button>

                                        </Flex>

                                        <SquarePaymentForm amount={paymentValue} billingContact={jobsheet.customer} callback={showPaymentToastFixed} />

                                    </Flex>
                                </ErrorBoundary>
                                :
                                // if we have a card on file must first check it is SCA
                                <Flex>
                                    {/* @ts-ignore */}
                                    {cardDetails?.card?.is_sca === true &&
                                        <ErrorBoundary FallbackComponent={ErrorFallback}>

                                            <Flex mt={4} p={2} direction='column' align='center'>

                                                <Flex direction='column'>
                                                    <Heading size="md" color='var(--Able-blue)' textAlign={"center"}>Payment Required</Heading>
                                                    <Text pl={2} pt={2} textAlign='center'>For this job, payment is needed after the first visit, we already have a payment method on you account</Text>
                                                    <Text align='center'> </Text>
                                                    <Text align='center'> Would you like to use the card &#8226;&#8226;&#8226;&#8226; &#8226;&#8226;&#8226;&#8226; &#8226;&#8226;&#8226;&#8226; {cardDetails?.card.card_number}?</Text>
                                                    <Flex direction='row' justify="center">
                                                        <Flex direction='row' justify="center">
                                                            <Link color='blue.500' onClick={useNewCard}>Change Card</Link>
                                                        </Flex>
                                                    </Flex>


                                                </Flex>

                                                <Text mt={5}>Deposit Value: <b>£{paymentValue.toFixed(2)}</b></Text>

                                                <Flex direction='row'>
                                                    <Button colorScheme='blue' variant='ghost' ml={4} onClick={openPaymentModal}>Change Amount</Button>
                                                    {jobsheet.value_deposit_expected != null &&
                                                        <Button colorScheme='blue' variant='ghost' ml={4} onClick={() => setPaymentValue(jobsheet?.value_gross ?? 0)}>Reset</Button>
                                                    }
                                                    <Button colorScheme='blue' variant='ghost' ml={4} onClick={() => setPaymentValue(jobsheet.value_gross - jobsheet.value_paid)}>Pay Balance Now</Button>

                                                </Flex>
                                                {!getSecondCard ?
                                                    <SquarePaymentFormExisting amount={paymentValue} billingContact={jobsheet.customer} customerId={jobsheet.id} sci={cardDetails?.card.square_card_identifier} callback={refresh} />
                                                    :
                                                    <SquarePaymentForm amount={paymentValue} billingContact={jobsheet.customer} callback={refresh} />
                                                }
                                            </Flex>
                                        </ErrorBoundary>
                                    }
                                </Flex>

                            }
                        </Flex>
                    </ErrorBoundary>
                )
            } else if (jobsheet.status_reason?.friendly_id == "invconf") {
                return (
                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                        <InvoiceConfirmation jobsheet={jobsheet} wiplines={wipLines} completeCallback={refresh}/>
                    </ErrorBoundary>
                )
            } else {
                return (
                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                        <Flex borderWidth='2px' borderColor='gray.200' borderRadius='lg' mt={4} p={2} align='center' justify='center'>
                            <Flex direction="column" w='full'>
                                <Heading size="md" color='var(--Able-blue)'>Query</Heading>
                                <Text>A query has been raised for your job, we are dealing with it as quickly as possible.</Text>
                                <Text>There is nothing you need to do at this time.</Text>
                                <Text> {jobsheet.status_reason?.name}</Text>
                                <Text> {jobsheet.status_reason?.friendly_id}</Text>
                                <Text w="full" textAlign="right" mt="0" fontSize="sm" color="gray.400">Last
                                    Updated: {GetDateTimeFromTimestamp(jobsheet.status_last_updated, "LTS")}</Text>
                            </Flex>
                        </Flex>
                    </ErrorBoundary>
                )
            }
        }

        else {
            switch (stage) {
                case JobOverviewStage.Cancelled:
                    return (
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <Text align='center' mt={4}>Your job has been cancelled.</Text>
                        </ErrorBoundary>
                    )

                case JobOverviewStage.AwaitingEngineer:
                    return (
                        //@ts-ignore
                        <Flex direction='column' mt={4}>
                            <Text align='center'>Your work has been booked in.</Text>
                            <Text align='center'>There is nothing further you need to do and we will be in touch when you need to sign your 'Right To Cancel' agreement.</Text>
                        </Flex>
                    )

                // case JobOverviewStage.EngineerAllocated:
                //     return (
                //         <Flex direction='column' mt={4}>
                //             <Text align='center'>An engineer has been allocated for your work.</Text>
                //             <Text align='center'>There is nothing further you need to do and we will be in touch when you need to sign your 'Right To Cancel' agreement.</Text>
                //         </Flex>
                //     )

                case JobOverviewStage.Assessment:
                    return (
                        <Flex direction='column' mt={4}>
                            <Text align='center'>Our engineer has arrived and is assessing the work required.</Text>
                        </Flex>
                    )

                case JobOverviewStage.RightToCancel:
                    return (
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <Flex direction='column' mt={4}>
                                <Text align='center'>Our engineer has assessed the work required and requires you to sign your Right to Cancel before proceeding with the job.</Text>
                                <br />
                                <DescriptionOfWorks
                                    jobsheet={jobsheet}
                                    appointmentWipLines={appointmentWipLines}
                                    otherWipLines={otherWipLines}
                                    showCleardownPlan={false}
                                />

                                <RTCView cb={refresh} jobNumber={jobsheet.id} isDamage={isWipDamaging()} customerType={jobsheet.customer?.Type ?? 0} />
                            </Flex>
                        </ErrorBoundary>
                    )

                case JobOverviewStage.Ordering:
                    return (
                        <Flex borderWidth='2px' borderColor='gray.200' borderRadius='lg' mt={4} p={2} alignSelf='center'>
                            <Flex align='center' direction='column'>
                                <Flex direction='column'>
                                    <Heading size="md" color='var(--Able-blue)'>Ordering Materials</Heading>
                                    <Text pl={2} pt={2} align='center'>One or more items have been placed on order. We are currently waiting for the materials to arrive. A new appointment will be booked in to continue your work once materials arrive.</Text>
                                </Flex>
                            </Flex>
                        </Flex>
                    )

                case JobOverviewStage.WorkInProgress:
                    return (
                        <Flex direction='column' mt={4}>
                            <Text align='center'>You have signed your 'Right to Cancel' and our engineer can now commence with the work required.</Text>
                            <br></br>
                            {showBox && !hasCardDetails &&
                                <Box borderWidth={"2px"} paddingTop={"1%"} borderRadius={"lg"}>
                                    {showYesNo &&
                                        <>
                                            <Text align={"center"}>You can add your payment card now and speed up checkout when the job is complete!</Text>
                                            <Flex direction="row" mt={4} justifyContent="center">
                                                <Button margin={"1%"} onClick={addPaymentMethodForm}>Yes</Button>
                                                <Button margin={"1%"} onClick={dontAddMethod}>No</Button>
                                            </Flex>
                                        </>
                                    }
                                    {showTokeniseForm &&
                                        <>
                                            <Text textAlign={"center"}>Feel free to enter your details below, your card will NOT be charged</Text>
                                            <SquareTokenizeForm billingContact={jobsheet.customer} callback={handleTokeniseCompleted} />
                                        </>
                                    }
                                </Box>
                            }
                        </Flex>
                    )

                case JobOverviewStage.WorkReport:
                    return (
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <Flex direction='column' mt={4}>
                                <Text align='center'>Our engineer has now completed the work required.</Text>
                                <DescriptionOfWorks
                                    jobsheet={jobsheet}
                                    appointmentWipLines={appointmentWipLines}
                                    otherWipLines={otherWipLines}
                                    showCleardownPlan={true}
                                />
                                <Box borderWidth='1px' borderColor='gray.400' borderRadius='lg' p={2} h='full' marginTop={"15px"}>
                                    <Heading size='md' color='var(--Able-blue)' borderBottom='2px' borderColor='gray.200' p={2}>Work Report</Heading>
                                    <WorkCompletedView jobNumber={jobsheet.id} cb={refresh} />
                                </Box>
                            </Flex>
                        </ErrorBoundary>
                    )

                case JobOverviewStage.PendingCompletion:
                    return (
                        <Flex direction='column' mt={4}>
                            <Text align='center'>Your job is now complete. Our engineer is just finalising the job before payment can be made.</Text>
                        </Flex>
                    )

                case JobOverviewStage.Payment:

                    return (
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <Flex direction='column' paddingTop={"2%"}>
                                {/* <Grid templateColumns={{base: '1fr', '2xl': '1fr 1fr'}} gap={2} mt={4} w='full'>
                                    <GridItem>

                                        <DescriptionOfWorks
                                            jobsheet={jobsheet}
                                            appointmentWipLines={appointmentWipLines}
                                            otherWipLines={otherWipLines}
                                            showCleardownPlan={true}
                                        />
                                    </GridItem>
                                    <GridItem marginBottom={"2px"}>
                                        <Pricing jobsheet={jobsheet}/>
                                    </GridItem>
                                </Grid> */}
                                {hasCardDetails ?                                
                                    (cardDetails?.card?.is_sca && cardDetails.card.is_sca === true ?
                                        //if the card is on file AND has SCA then we need to reverify the card BUT we can just use the card on file
                                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                                            <>
                                                <Box borderWidth={"2px"} paddingTop={"1%"} borderRadius={"lg"} marginTop={"15px"}>
                                                    <Text align='center' fontSize={"2xl"}>Your job is now complete and payment can be made below.</Text>
                                                    <Box height={"10px"}></Box>
                                                    <Text align='center'> We already have a payment method on you account</Text>
                                                    <Text align='center'> Would you like to use the card &#8226;&#8226;&#8226;&#8226; &#8226;&#8226;&#8226;&#8226; &#8226;&#8226;&#8226;&#8226; {cardDetails?.card.card_number}?</Text>
                                                    <Flex direction='row' justify="center">
                                                        <Flex direction='row' justify="center">
                                                            <Link color='blue.500' onClick={useNewCard}>Change Card</Link>
                                                        </Flex>
                                                    </Flex>
                                                    <Flex direction='row' mt={4} justify='center'>
                                                        <Text>Outstanding Balance: <b> £{(jobsheet.value_gross - jobsheet.value_paid).toFixed(2)}</b></Text>
                                                        <Link ml={8} color='blue.500' onClick={() => setPaymentModalOpen(true)}>Change amount</Link>

                                                    </Flex>
                                                    <></>
                                                    <SquarePaymentFormExisting amount={paymentValue} billingContact={jobsheet.customer} customerId={jobsheet.id} sci={cardDetails?.card.square_card_identifier} callback={refresh} />
                                                </Box>
                                            </>
                                        </ErrorBoundary>
                                        :
                                        //if the card does not have SCA then we ask for a new one to be entered 
                                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                                            <>
                                                <Box borderWidth={"2px"} paddingTop={"1%"} borderRadius={"lg"} marginTop={"15px"}>
                                                    <Text align='center' fontSize={"2xl"}>Your job is now complete and payment can be made below.</Text>
                                                    <Box height={"10px"}></Box>
                                                    <Text align={"center"}>We already have your Card on the system but for verification purposes please enter them again below</Text>
                                                    <Flex direction='row' justify="center">
                                                    </Flex>
                                                    <Flex direction='row' mt={4} justify='center'>
                                                        <Text>Outstanding Balance: <b> £{(jobsheet.value_gross - jobsheet.value_paid).toFixed(2)}</b></Text>
                                                        <Link ml={8} color='blue.500' onClick={() => setPaymentModalOpen(true)}>Change amount</Link>

                                                    </Flex>
                                                    <></>
                                                    <SquarePaymentForm amount={paymentValue} billingContact={jobsheet.customer} callback={refresh} />
                                                </Box>
                                            </>
                                        </ErrorBoundary>
                                    )
                                    :
                                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                                        <>  {/*if we don't already have card details on the system*/}
                                            <Box borderWidth={"2px"} paddingTop={"1%"} borderRadius={"lg"} marginTop={"15px"}>
                                                <Text align='center' fontSize={"2xl"}>Your job is now complete and payment can be made below.</Text>
                                                <Box height={"10px"}></Box>
                                                <Text align='center'> We don't currently have any payment details linked to your account, please provide a payment method below</Text>
                                                <Flex direction='row' mt={4} justify='center'>
                                                    <Text>Outstanding Balance: <b> £{(jobsheet.value_gross - jobsheet.value_paid).toFixed(2)}</b></Text>
                                                    <Link ml={8} color='blue.500' onClick={() => setPaymentModalOpen(true)}>Change amount</Link>
                                                </Flex>
                                                <SquarePaymentForm amount={paymentValue} billingContact={jobsheet.customer} callback={refresh} />
                                            </Box>
                                        </>
                                    </ErrorBoundary>
                                }

                                <CompletedWorkSummary jobsheet={jobsheet} rightToCancel={rightToCancel} workReport={workReport}/>


                                <ErrorBoundary FallbackComponent={ErrorFallback}>
                                    <Box borderWidth={"2px"} paddingBottom={"2%"} paddingTop={"1%"} borderRadius={"lg"}>
                                        <Text paddingTop={"1%"} align='center'>Overall, how would you rate your experience of using our services?</Text>
                                        <HStack direction='row' mt={2} justify='center' spacing={4}>
                                            <IconButton size='lg' color={sentiment == 0 ? "red" : "primary"} onClick={() => setSentiment(0)} aria-label="dissatisfied" >
                                                <TbMoodSad fontSize={"40px"} />
                                            </IconButton>
                                            {/*<IconButton size='lg' color={sentiment == 1 ? "orange" : "primary"} onClick={() => setSentiment(1)} aria-label="neutral">
                            <MdSentimentNeutral />
                          </IconButton>*/}
                                            <IconButton size='lg' color={sentiment == 2 ? "green" : "primary"} onClick={() => setSentiment(2)} aria-label="happy" >
                                                <TbMoodHappy fontSize={"40px"} />
                                            </IconButton>
                                        </HStack>
                                    </Box>
                                </ErrorBoundary>
                            </Flex>
                        </ErrorBoundary>
                    )

                case JobOverviewStage.Completed:
                    return (
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <Flex direction='column' mt={4}>
                                <Text align='center' mb={2}>Your job is now complete and paid for. Your business is really appreciated.</Text>
                                <div ref={componentRef} style={{ position: "relative" }}>
                                    <CompletedWorkSummary jobsheet={jobsheet} rightToCancel={rightToCancel} workReport={workReport}/>
                                </div>
                                    {/* {sentiment === -1 && showError &&
                                        <>
                                            <ErrorBoundary fallbackRender={ErrorFallback}>
                                                <Text align='center'> {jobsheet.customer?.Name}, Thank you for using the Customer Portal</Text>
                                            </ErrorBoundary>
                                        </>
                                            
                                    }
                                    {sentiment == 2 &&
                                        <><Text align='center'> {jobsheet.customer?.Name}, Thank you for using the Customer Portal</Text></>
                                            
                                    } */}
                                {sentiment == SatisfactionRating.UnHappy &&
                                    <Box p={2} mt={2} borderColor='gray' borderWidth={1} borderRadius={5} maxHeight='2100px' overflowY='auto'>
                                        <Text align='center'>{jobsheet.customer?.Name}, sorry to hear you were not completely happy with our services.</Text>
                                            <Text align='center'>Feel free to leave your name, and email address and a member of our team will get in touch to assist you.</Text>
                                            <Flex justifyContent={"center"} paddingTop={"1%"}>
                                                <Box justifyContent={"center"} h='50%' w={"30%"} bg="white" color="black" paddingLeft={"1%"} paddingRight={"1%"} paddingTop={"1%"} borderWidth="5px" borderColor={"var (--Able-blue)"}>
                                                    <Heading size='lg' mb={4} textAlign='center' textColor='var(--Able-blue)'>Feedback Form</Heading>

                                                    {formIsSent == false &&
                                                        <>
                                                            <ErrorBoundary FallbackComponent={ErrorFallback}>
                                                                <Text align={'center'} fontSize={"lg"}>In order to respond to your feedback, all we neeed is your Job Number, Name and Contact Details.</Text>
                                                                <br />
                                                                <Text align={'center'} fontSize={"lg"}>Once you click sumbit a member of our team will be in touch to help resolve your issue.</Text>
                                                                <form onSubmit={handleSubmit}>
                                                                    <Flex paddingTop={"3%"}>
                                                                        <InputGroup>
                                                                            <InputLeftElement
                                                                                pointerEvents={"none"}
                                                                                children={<MdDriveFileRenameOutline color='grey' />} />
                                                                            <Input placeholder={"Name"} type={"text"} onChange={(e: any) => setName(String(e.target.value))} required />
                                                                        </InputGroup>
                                                                    </Flex>
                                                                    <Flex paddingTop={"3%"}>

                                                                        <InputGroup>
                                                                            <InputLeftElement
                                                                                pointerEvents={"none"}
                                                                                children={<MdAlternateEmail color='grey' />} />
                                                                            <Input id="email" placeholder={"Email"} type={"text"} onChange={(e: any) => setEmail(String(e.target.value))} isInvalid={!validateEmail(email)} />
                                                                        </InputGroup>

                                                                    </Flex>
                                                                    <Flex paddingTop={"3%"}>
                                                                        <InputGroup>

                                                                            <Textarea placeholder={"Please provide a brief summary of your query"} onChange={(e: any) => setNotes(String(e.target.value))} resize={"none"} required />
                                                                        </InputGroup>
                                                                    </Flex>
                                                                    <Flex direction={"column"} w={"100%"} mt={5} alignItems={"top"} justifyContent="center" gap="2" paddingTop={"0%"} paddingLeft={"39%"} paddingBottom={"5%"}>
                                                                        <Button type="submit" alignContent={"center"} variant="solid" mr={2} colorScheme="facebook" w={100}
                                                                            onClick={() => {
                                                                                handleSubmit();
                                                                                setLoadingButton(true);
                                                                            }
                                                                            }
                                                                            isDisabled={!validateEmail(email)}>Submit</Button>
                                                                    </Flex>
                                                                </form>
                                                            </ErrorBoundary>
                                                        </>
                                                    }
                                                    {formIsSent &&
                                                        <Text align={"center"} paddingBottom={"5%"}>Thank you for submitting feedback, a member of our team will be in touch shortly</Text>}
                                                </Box>
                                            </Flex>
                                        </Box>
                                    }
                            </Flex>
                        </ErrorBoundary>
                    )

                default:
                    return <Text>Oops! Something went wrong. Unable to determine job stage.</Text>
            }
        }
    }

    const isOrderJob = (): boolean => {
        let result = false;
        wipLines.forEach((wip) => {
            if (wip.is_order_line) {
                result = true;
            }
        })
        return result;
    }

    //@ts-ignore
    function ErrorFallback({ error, resetErrorBoundary }) {
        return (
            <>
                <div role="alert">
                    <p> Something went wrong:</p>
                    <pre>{error.message}</pre>
                    <button type="submit" onClick={resetErrorBoundary}>Try again</button>
                </div>
            </>
        );
    }
    useEffect(() => {
        if (jobsheet?.value_deposit_expected != null && modalPayment == 0) {
            setPaymentErrorMsg("Value cannot be 0")
        }
        else if (jobsheet?.value_deposit_expected != null && modalPayment < jobsheet.value_deposit_expected) {
            setPaymentErrorMsg("Value cannot be lower than minimum deposit");
        }
        else if (jobsheet?.value_deposit_expected != null && modalPayment > jobsheet.value_gross + jobsheet.value_paid) {
            setPaymentErrorMsg("Value cannot exceed total price");
        }
    }, [modalPayment]);
    useEffect(() => {
        if (jobsheet === null && !loading) {
            setLoading(true);

            if (jobNumber != null) {
                refresh();
            }
            else {
                navigate("/customer/signout");
            }
        }
    }, []);

    useEffect(() => {
        sendDataToGTM({ jobNumber: jobsheet?.id, jobValue: jobsheet?.value_gross });
    }, [jobsheet])

    useEffect(() => {
        if (jobsheet != null && wipLines.length > 0) {
            if (loading) {
                setLoading(false);
            }
        }
    }, [jobsheet, wipLines]);

    useEffect(() => {
        calculateStage();
    }, [jobsheet, appointmentWipLines, rightToCancel, workReport, otherWipLines, hasCardDetails, getSecondCard])

    if (loading || jobsheet == null || jobNumber == null) {
        return (
            <PageContainer pageTitle="Your Job">
                {/* <Heading textColor='var(--Able-blue)' size='lg' textAlign='center' m={4}>{loadingGif}</Heading> */}
                {/* @ts-ignore */}
                <Flex direction={"row"} justifyContent={"center"} width={"100%"} marginTop={"11%"} bgColor={"white"}>
                    {!timedOut ?
                        <Image srcSet={loadingGif} alt="loading..." boxSize={'400px'} objectFit={"cover"} />
                        :
                        <Image srcSet={loadingError} alt="request timed out!" boxSize={"400px"} objectFit={"cover"} />
                    }

                </Flex>
                {/* this is the skeleton loading screen */}
                {/* <Flex width={"100%"} justifyContent={"center"}>
                <Progress 
                size={"xs"} 
                value={50}
                marginTop={"15%"}
                width={"50%"} 
                isIndeterminate
                />
                </Flex> */}


            </PageContainer>
        );
    }

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <PageContainer pageTitle="Your Job" type={PortalPageType.Customer}>
                <Box w='full' fontSize={{ base: "md", lg: "lg" }} justifyContent={"center"} alignItems={"center"}>
                    <JobStageStepper jobStage={stage} isOrdering={isOrderJob()} isRightToCancel={rightToCancel?.allow_digital ?? false} />

                    {getInteraction()}

                    {stage < JobOverviewStage.Payment && showInteractionOnly === false &&
                        <Flex direction='column' gap={2} mt={4} w='full'>

                            {/* Appointment Box */}
                            {jobsheet.appointment &&
                                <AppointmentDetails jobsheet={jobsheet} showBilling={jobsheet.status_reason?.friendly_id == "invconf"}/>
                            }

                            {/* Wiplines Box */}
                            {(stage != 3 && stage != 6 && stage != 8) &&
                                <ErrorBoundary FallbackComponent={ErrorFallback}>
                                    <DescriptionOfWorks
                                        jobsheet={jobsheet}
                                        appointmentWipLines={appointmentWipLines}
                                        otherWipLines={otherWipLines}
                                        showCleardownPlan={false}
                                    />
                                </ErrorBoundary>
                            }

                            {/* Pricing Box */}
                            {stage != 8 &&
                                <Pricing jobsheet={jobsheet}/>
                            }

                            {/* Hazardous Substances Box */}
                            <PoisonCoshhSummary jobNumber={jobsheet.id}/>
                        </Flex>
                    }
                </Box>

                {/* Modal for editing payment value */}
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <Modal isOpen={paymentModalOpen} onClose={() => setPaymentModalOpen(false)}>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Input Amount</ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>

                                <Flex justifyItems='center'>
                                    <FormControl isInvalid={(modalPayment > jobsheet.value_gross - jobsheet.value_paid) ||
                                        (jobsheet.value_deposit_expected != null && modalPayment < jobsheet.value_deposit_expected) ||
                                        (jobsheet.value_deposit_expected != null && modalPayment <= 2)}>
                                        <FormLabel>Please enter the new amount</FormLabel>
                                        <InputGroup>
                                            <InputLeftAddon>£</InputLeftAddon>
                                            <Input type="number" step={0.01} value={modalPayment > 0 ? modalPayment : ""} isInvalid={isInvalidPayment()} onChange={(e: any) => setModalPayment(Number(e.target.value))} />
                                        </InputGroup>
                                        {/*code added goes here*/}
                                        <FormErrorMessage>{paymentErrorMsg}</FormErrorMessage>
                                    </FormControl>
                                </Flex>
                            </ModalBody>
                            <ModalFooter>
                                <Button variant="ghost" mr={2} w={100} onClick={() => setPaymentModalOpen(false)}>Cancel</Button>
                                <Button colorScheme='green' w={100} onClick={setPaymentFromModal} isDisabled={isInvalidPayment()}>OK</Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>
                </ErrorBoundary>
            </PageContainer>
        </ErrorBoundary>
    );
}